import useLocalStorage, { getLocalStorageItem } from './useLocalStorage';

// Features that are off by default but can be previewed per browser, e.g. in prod by the product team.
// Toggle them in the backoffice (Feature toggles), or with `?preview=<name>` on any page and `?preview=off` for all.
export type FeaturePreview = 'collections-hub' | 'latest-update-teaser' | 'public-kpis';

export const featurePreviews: { name: FeaturePreview; label: string }[] = [
  { name: 'collections-hub', label: 'New Collections page (companies table, list cards and suggestions)' },
  { name: 'latest-update-teaser', label: 'Latest update teaser on the company profile tab' },
  {
    name: 'public-kpis',
    label: 'Public KPIs for visitors with a follow prompt, and the "make a KPI public" nudge and to-do for founders',
  },
];

const storageKey = (name: FeaturePreview) => `preview:${name}`;

function applyPreviewParam() {
  const param = new URLSearchParams(window.location.search).get('preview');
  if (!param) return;

  if (param === 'off') {
    Object.keys(window.localStorage)
      .filter(key => key.startsWith('preview:'))
      .forEach(key => window.localStorage.removeItem(key));
  } else {
    window.localStorage.setItem(storageKey(param as FeaturePreview), JSON.stringify(true));
  }
}

export default function useFeaturePreview(name: FeaturePreview): boolean {
  applyPreviewParam();
  return getLocalStorageItem(storageKey(name), false);
}

export function useFeaturePreviewSetting(name: FeaturePreview) {
  const [value, setValue] = useLocalStorage(storageKey(name), false);
  return [value ?? false, setValue] as const;
}
